
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/tanabata",
      function () {
        return require("private-next-pages/features/tanabata.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/tanabata"])
      });
    }
  